import Layout from '../Layout'

const Page = (props) => {
  return (
    <Layout />
  )
}

export default Page
